/**
 * Treydorex sale env — checks explicit CRA env (not dev fallbacks from trdxContractConfig).
 */

import {
  resolveTrdxUsdcAddressFromEnv,
  resolveTrdxUsdcEnvKeyUsed,
} from "../../config/trdxUsdcEnv";

function looksLikeEthAddress(value) {
  return /^0x[a-fA-F0-9]{40}$/.test(String(value ?? "").trim());
}

/** True when all required REACT_APP_TRDX_* vars are set to non-empty, valid-looking values. */
export function isTrdxSaleEnvExplicitlyConfigured() {
  const chainIdRaw = String(process.env.REACT_APP_TRDX_CHAIN_ID ?? "").trim();
  const token = String(process.env.REACT_APP_TRDX_TOKEN_ADDRESS ?? "").trim();
  const sale = String(process.env.REACT_APP_TRDX_SALE_ADDRESS ?? "").trim();
  const usdc = resolveTrdxUsdcAddressFromEnv();

  if (!chainIdRaw || !token || !sale || !usdc) return false;
  if (!looksLikeEthAddress(token) || !looksLikeEthAddress(sale) || !looksLikeEthAddress(usdc)) {
    return false;
  }
  const chainId = parseInt(chainIdRaw, 10);
  return Number.isFinite(chainId) && chainId > 0;
}

/** True when a dedicated read-only RPC is set (recommended for Netlify / browser reads). */
export function isTrdxReadRpcExplicitlyConfigured() {
  if (String(process.env.REACT_APP_TRDX_RPC_URL ?? "").trim()) return true;
  const chainId = parseInt(String(process.env.REACT_APP_TRDX_CHAIN_ID ?? "").trim(), 10);
  if (chainId === 1 && String(process.env.REACT_APP_MAINNET_RPC_URL ?? "").trim()) return true;
  if (chainId === 11155111 && String(process.env.REACT_APP_SEPOLIA_RPC_URL ?? "").trim()) return true;
  return false;
}

export function getTrdxSaleEnvSummary() {
  return {
    chainId: String(process.env.REACT_APP_TRDX_CHAIN_ID ?? "").trim(),
    tokenAddress: String(process.env.REACT_APP_TRDX_TOKEN_ADDRESS ?? "").trim(),
    saleAddress: String(process.env.REACT_APP_TRDX_SALE_ADDRESS ?? "").trim(),
    usdcAddress: resolveTrdxUsdcAddressFromEnv(),
    usdcEnvKeyUsed: resolveTrdxUsdcEnvKeyUsed(),
    rpcUrlConfigured: isTrdxReadRpcExplicitlyConfigured(),
  };
}
